export default "__VITE_ASSET__5J2BLdkC__"